var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewpassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.29,
    height: 14,
    viewBox: "0 0 22.29 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#3f66b3}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer",
    transform: "translate(-.83 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_108",
    "data-name": "Vrstva 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_118",
    d: "M22.85 11.48v-.06l-.14-.21c-.13-.18-.31-.43-.54-.73a16.42 16.42 0 0 0-2.07-2.2A12.22 12.22 0 0 0 12 5a12.22 12.22 0 0 0-8 3.25 16.42 16.42 0 0 0-2.07 2.2c-.23.3-.41.55-.54.73l-.14.21v.06L.83 12l.32.54v.06l.14.21c.13.18.31.43.54.73A16.42 16.42 0 0 0 4 15.75 12.22 12.22 0 0 0 12 19a12.22 12.22 0 0 0 8.05-3.25 16.42 16.42 0 0 0 2.07-2.2c.23-.3.41-.55.54-.73l.14-.21v-.06l.32-.52zm-2.31.84a14.36 14.36 0 0 1-1.81 1.93A10.2 10.2 0 0 1 12 17a10.2 10.2 0 0 1-6.73-2.75 15.23 15.23 0 0 1-1.82-1.93L3.21 12l.24-.32a15.23 15.23 0 0 1 1.82-1.93A10.2 10.2 0 0 1 12 7a10.2 10.2 0 0 1 6.73 2.75 14.36 14.36 0 0 1 1.81 1.93c.1.12.18.22.25.32s-.15.2-.25.32z",
    className: "prefix__cls-1",
    "data-name": "Trazado 118"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Elipse_8",
    cx: 3,
    cy: 3,
    r: 3,
    className: "prefix__cls-1",
    "data-name": "Elipse 8",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewpassword);
export default __webpack_public_path__ + "static/media/viewpassword.8a69914c.svg";
export { ForwardRef as ReactComponent };